var exports = {
  "mc": "Container__7aaJWU",
  "E4": "UserLink__SL4K_N",
  "re": "GitHubAvatar__OAk2y_",
};

module.exports = exports;
